import { useState } from 'react';
import { Container, Card, CardHeader, CardContent, Typography, Button, Box, CircularProgress, Alert } from '@mui/material';
import { post } from './apiClient';

export default function BillingPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleManageBilling = async () => {
    setLoading(true);
    setError(null);
    try {
      const { url } = await post('/billing/create-portal-session', {
        return_url: window.location.href,
      });
      window.location.href = url;
    } catch (err) {
      setError('Could not open the billing portal. Please try again.');
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Card>
        <CardHeader title="Billing Management" />
        <CardContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Typography variant="body1" sx={{ mb: 2 }}>
            Click the button below to manage your subscription, view your invoice history,
            and update your payment methods.
          </Typography>
          <Box>
            <Button
              variant="contained"
              onClick={handleManageBilling}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Manage Billing & Invoices'}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}
